export default "__VITE_ASSET__68c32045__"